import { motion } from "framer-motion";
import { Globe, MapPin, Search, Share2, PenTool, LifeBuoy } from "lucide-react";

const services = [
  {
    icon: Globe,
    title: "Website Design & Build",
    desc: "A clean, fast, mobile-ready website that turns visitors into customers.",
    span: "md:col-span-7",
    tint: true,
  },
  {
    icon: MapPin,
    title: "Google Business Profile",
    desc: "Show up on Maps and local search, set up the right way.",
    span: "md:col-span-5",
  },
  {
    icon: Search,
    title: "Basic SEO",
    desc: "Get found by the people searching for what you offer.",
    span: "md:col-span-5",
  },
  {
    icon: Share2,
    title: "Social Media Setup",
    desc: "Polished, on-brand profiles ready to post from day one.",
    span: "md:col-span-7",
    tint: true,
  },
  {
    icon: PenTool,
    title: "Branding & Logo Design",
    desc: "A memorable logo, colours and fonts that feel like you.",
    span: "md:col-span-6",
  },
  {
    icon: LifeBuoy,
    title: "Ongoing Care",
    desc: "Updates, hosting and a real person to call when you need help.",
    span: "md:col-span-6",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 sm:py-32">
      <div className="mx-auto max-w-6xl px-6 sm:px-12">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#75C69F]">
            What we do
          </span>
          <h2 className="mt-4 font-heading text-4xl font-medium tracking-tight text-[#0B281B] sm:text-5xl">
            Everything to get you online — in one place.
          </h2>
          <p className="mt-5 text-lg text-[#4A6657]">
            Pick a package or mix and match. We handle the tech so you can focus
            on running your business.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-12">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                data-testid={`service-card-${i}`}
                className={`group rounded-3xl border border-[#DCECE3] p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(152,216,186,0.18)] ${
                  s.tint ? "bg-[#F0F5F2]" : "bg-white"
                } ${s.span}`}
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#98D8BA] transition-transform group-hover:scale-110">
                  <Icon className="h-6 w-6 text-[#0B281B]" strokeWidth={1.75} />
                </span>
                <h3 className="mt-6 font-heading text-2xl font-medium text-[#0B281B]">
                  {s.title}
                </h3>
                <p className="mt-3 max-w-md text-[#4A6657]">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
